import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Typography, Hidden } from '@material-ui/core';
import clsx from 'clsx';

// Import components
import { useTranslations } from 'components/utilities';
import { useStyles } from './styles';
import AirportItem from './AirportItem';
import { Header } from './Header';

import { configurationSelectors } from 'store/selectors';

function Departure() {
	const { t } = useTranslations();
	const classes = useStyles();

	const { isLoading, item } = useSelector(configurationSelectors.getAll);

	return (
		<>
			<Box className={classes.container}>
				<Box className={classes.wrapper}>
					<Header />
					<Typography className={classes.subtitle}>
						{t('departure.subHeader1')}
					</Typography>
					<Typography className={clsx([classes.subtitle, classes.subtitle2])}>
						{t('departure.subHeader2')}
					</Typography>
					<Hidden smDown>
						<Typography className={`${classes.subtitle} ${classes.mt}`}>
							{t('departure.subHeader3')}
						</Typography>
					</Hidden>
					<Box className={classes.grid}>
						{!isLoading &&
							item.airportList
								.filter((airport) => airport.uuid !== item.airportUuid)
								.map((airport) => (
									<AirportItem key={airport.uuid} airport={airport} />
								))}
					</Box>
				</Box>
			</Box>
		</>
	);
}

export default Departure;
